import { motion } from "motion/react";
import clsx from "clsx";
import { ElectricIcon, FuelIcon } from "@/shared/icons";
import { getElectricFuelCells } from "@/domains/gasStation/helpers/getElectricFuelCells";
import GasStationWave from "@/domains/gasStation/components/GasStationWave";

type Props = {
  isElectric?: boolean;
  fuel: number;
  fuelCapacity: number;
};
export default function GasStationFuelTank({ fuel, fuelCapacity, isElectric }: Props) {
  const fuelPercent = fuelCapacity === 0 ? 0 : Number(((fuel / fuelCapacity) * 100).toFixed(0));

  return (
    <div
      className={clsx(
        "flex flex-col items-center gap-2 h-[14.625rem] w-[3.375rem] px-1.5 pb-1.5 pt-3",
        "border-[2px] border-accent-muted/20",
        isElectric ? "rounded-[1rem]" : "rounded-[4.375rem]",
      )}
    >
      {isElectric ? (
        <ElectricIcon size={20} className="text-accent-solid" />
      ) : (
        <FuelIcon size={20} className="text-accent-solid" />
      )}
      <div className="text-16 font-medium text-accent whitespace-nowrap">
        {isElectric ? `${fuelPercent}%` : `${Math.ceil(fuel)}L`}
      </div>
      {isElectric ? (
        <div className="flex flex-col-reverse w-full h-[9.875rem] rounded-[0.75rem] gap-0.5 overflow-clip">
          {getElectricFuelCells(fuelPercent).map((item, index) => (
            <div
              key={`${index + index}`}
              className={clsx(
                "h-[0.875rem] w-full rounded-[0.250rem]",
                item ? "bg-accent-solid" : "bg-accent-muted/20",
              )}
            />
          ))}
        </div>
      ) : (
        <div className="w-full h-[9.875rem] rounded-[4.375rem] overflow-clip relative bg-accent-muted/20">
          <motion.div
            initial={{ opacity: 0, translateY: "100%" }}
            animate={{ opacity: 1, translateY: `${100 - fuelPercent}%` }}
            transition={{
              duration: 0.3,
            }}
            className="flex flex-col h-full"
          >
            <GasStationWave className="[--color:--accent-solid]" />
            <div className="grow bg-accent-solid scale-110" />
          </motion.div>
        </div>
      )}
    </div>
  );
}
